<template>
  <div class="page-view">
    <route-view></route-view>
  </div>
</template>

<script>
import RouteView from './RouteView'

export default {
  name: 'CustomProGroupLayout',
  components: { RouteView },
  data() {
    return {}
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {}

}
</script>
<style lang="less" scoped>
.page-view {
  background: #f0f2f5;
  width: 100%;
  min-height: 100%;
}
</style>